import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
 selector: 'app-confirm-dialog',
 standalone: true,
 imports: [CommonModule, MatButtonModule],
 templateUrl: './confirm-dialog.component.html',
 styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
 constructor(
 public dialogRef: MatDialogRef<ConfirmDialogComponent>,
 @Inject(MAT_DIALOG_DATA) public data: { title?: string; message: string; confirmText?: string; cancelText?: string }
 ) {}

 confirm() {
 this.dialogRef.close(true);
 }

 cancel() {
 this.dialogRef.close(false);
 }
}
